import React from 'react';

function BackButton() {

    return (
        <div className='my-5'>
            <a
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-800"
                href="/#services"
            >
                &larr; Back
            </a>
        </div>
    );
}

export default BackButton;